import { render } from "./TagEdit.vue?vue&type=template&id=135f170e"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__